module.exports = __webpack_public_path__ + "static/Eliza2-36c4fd9bce90f23f4ba03a3300a9bb59.png";